import React, { useState } from 'react'
// import styles from './ViewersTable.module.scss';
import { TableHeader } from './TableHeader'
import { TableContainer } from 'components/common'
import { TableLine } from './TableLine'
import { Props } from './types'
import { Viewer } from 'models'
import { inject } from 'mobx-react'
import { VIEWERS_STORE } from 'store'
import { observer } from 'mobx-react-lite'
import { SortTabEnums } from 'pages/viewers/ViewersPage/SortTabs'
import { SortDirection, isDescending } from 'utilities'

const ViewersTableComponent = (props: Props) => {
  const {
    list,
    [VIEWERS_STORE]: { selectedSortTab }
  } = props

  const [sortDirection, setSortDirection] = useState<SortDirection>(SortDirection.DESC)

  const sortByDynamicCol = {
    [SortTabEnums.TOTAL_WATCH]: (a: Viewer, b: Viewer) => {
      return isDescending(sortDirection)
        ? b.totalWatchTime - a.totalWatchTime
        : a.totalWatchTime - b.totalWatchTime
    },
    [SortTabEnums.INTERACTION_TIME]: (a: Viewer, b: Viewer) => {
      return isDescending(sortDirection)
        ? b.totalInteractionTime - a.totalInteractionTime
        : a.totalInteractionTime - b.totalInteractionTime
    },
    [SortTabEnums.ADD_REVENUE]: (a: Viewer, b: Viewer) => {
      return isDescending(sortDirection)
        ? b.totalAddRevenue - a.totalAddRevenue
        : a.totalAddRevenue - b.totalAddRevenue
    },
    [SortTabEnums.TOTAL_SPENT]: (a: Viewer, b: Viewer) => {
      return isDescending(sortDirection)
        ? b.totalSpent - a.totalSpent
        : a.totalSpent - b.totalSpent
    }
  }[selectedSortTab]

  return (
    <TableContainer
      preset='clean'
      headerComponent={
        <TableHeader
          sortDirection={sortDirection}
          setSortDirection={setSortDirection}
        />
      }
    >
      {list.sort(sortByDynamicCol).map((viewer: Viewer) =>
        <TableLine key={viewer.id} viewer={viewer} />
      )}
    </TableContainer>
  )
}

const ViewersTable = inject(VIEWERS_STORE)(observer(ViewersTableComponent))
export { ViewersTable }
